import { format } from 'date-fns'

export default function () {
  return {
    resultMessage: '',
    showResultDialog: false,
    loading: true,
    format,
  }
}
